export enum FeatureFlags {
  allowFreeFormMultiSelect = 'allowFreeFormMultiSelect',
  allowMultipleSendReminders = 'allowMultipleSendReminders',
  enableEditCommentsFromCard = 'enableEditCommentsFromCard',
  isBetaFeature = 'isBetaFeature',
  asOfCapTables = 'asOfCapTables',
  legalStructureEnabled = 'legalStructureEnabled',
  showAdminManageAccess = 'showAdminManageAccess',
  showAdminManageAccessColumnGridDisplay = 'showAdminManageAccessColumnGridDisplay',
  showAggFuncInKpiConfig = 'showAggFuncInKpiConfig',
  showAgentFeedback = 'showAgentFeedback',
  showAllSecurities = 'showAllSecurities',
  showArgusShadowCompare = 'showArgusShadowCompare',
  showBeneficialOwnership = 'showBeneficialOwnership',
  showCapTableAsOfDate = 'showCapTableAsOfDate',
  showCapTableSummaryGridConfig = 'showCapTableSummaryGridConfig',
  showCompanyMappings = 'showCompanyMappings',
  showDataCollectionConfig = 'showDataCollectionConfig',
  showDealDocsInActivityDrawer = 'showDealDocsInActivityDrawer',
  showDocumentHub = 'showDocumentHub',
  showDocumentHubPackaging = 'showDocumentHubPackaging',
  showDealTab = 'showDealTab',
  showEditTimeSeries = 'showEditTimeSeries',
  showEmailStatuses = 'showEmailStatuses',
  showFieldsManager = 'showFieldsManager',
  showFileKpiConfig = 'showFileKpiConfig',
  showFormattersConfig = 'showFormattersConfig',
  showFormulaFields = 'showFormulaFields',
  showFinancialsGrid2 = 'showFinancialsGrid2',
  showFrostedModules = 'showFrostedModules',
  showFundCapitalAllocation = 'showFundCapitalAllocation',
  showFundReporting = 'showFundReporting',
  showFundReserves = 'showFundReserves',
  showGeneralLedger = 'showGeneralLedger',
  showGlSoiRecon = 'showGlSoiRecon',
  showKpiGridWithHistoricalDataSupport = 'showKpiGridWithHistoricalDataSupport',
  showKpiSourceHierarchy = 'showKpiSourceHierarchy',
  showListDetailsAsPanel = 'showListDetailsAsPanel',
  showMetricsRecon = 'showMetricsRecon',
  showNewCreateCompanyFormInLists = 'showNewCreateCompanyFormInLists',
  showPeopleReporting = 'showPeopleReporting',
  showRoundSource = 'showRoundSource',
  showSourcing = 'showSourcing',
  showSecurityView = 'showSecurityView',
  showStockSplitInEquitySell = 'showStockSplitInEquitySell',
  showSummaryV2 = 'showSummaryV2',
  showStockSplitInShareExchange = 'showStockSplitInShareExchange',
  showTearsheetLayoutBuilder = 'showTearsheetLayoutBuilder',
  showWeightedScenarios = 'showWeightedScenarios',
  useKpiFileUpload3 = 'useKpiFileUpload3',
  useManagedServices = 'useManagedServices',
  useNewViewsP = 'useNewViewsP',
  useShowOwnershipTimeline = 'useShowOwnershipTimeline',
  useStarbreakerCollectionV2 = 'useStarbreakerCollectionV2',
  useTearsheetRendererV2 = 'useTearsheetRendererV2',
}

export function getFeatureFlagsDefaults() {
  return Object.keys(FeatureFlags).reduce(
    (res, key) => {
      res[key as FeatureFlags] = false;

      return res;
    },
    {} as Record<FeatureFlags, boolean>
  );
}

export type MaggieFeatureFlags = ReturnType<typeof getFeatureFlagsDefaults>;
